// Wind direction converter
export const getWindDirection = (degrees) => {
  if (degrees === undefined || degrees === null) return '';
  
  const directions = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
  const index = Math.round(degrees / 22.5) % 16;
  return directions[index];
};

// Temperature converters
export const celsiusToFahrenheit = (celsius) => Math.round((celsius * 9/5) + 32);
export const fahrenheitToCelsius = (fahrenheit) => Math.round((fahrenheit - 32) * 5/9);

// UV Index helpers
export const getUVIndexInfo = (uvIndex) => {
  if (uvIndex <= 2) {
    return {
      level: 'Low',
      color: 'bg-green-500',
      textColor: 'text-green-700',
      darkTextColor: 'dark:text-green-300',
      advice: 'No protection needed'
    };
  } else if (uvIndex <= 5) {
    return {
      level: 'Moderate',
      color: 'bg-yellow-500',
      textColor: 'text-yellow-700',
      darkTextColor: 'dark:text-yellow-300',
      advice: 'Protection needed during midday'
    };
  } else if (uvIndex <= 7) {
    return {
      level: 'High',
      color: 'bg-orange-500',
      textColor: 'text-orange-700',
      darkTextColor: 'dark:text-orange-300',
      advice: 'Protection essential'
    };
  } else if (uvIndex <= 10) {
    return {
      level: 'Very High',
      color: 'bg-red-500',
      textColor: 'text-red-700',
      darkTextColor: 'dark:text-red-300',
      advice: 'Extra protection needed'
    };
  } else {
    return {
      level: 'Extreme',
      color: 'bg-purple-600',
      textColor: 'text-purple-700',
      darkTextColor: 'dark:text-purple-300',
      advice: 'Avoid sun exposure 10am-4pm'
    };
  }
};

// Get water temp station friendly name
export const getWaterStationName = (stationId) => {
  const stationNames = {
    'PACF1': 'Panama City Beach',
    'APCF1': 'Apalachicola',
    'SAUF1': 'St. Augustine',
    'DRYF1': 'Dry Tortugas',
    'SMKF1': 'Sombrero Key',
    'SANF1': 'Sand Key',
    'LONF1': 'Long Key',
    'MLRF1': 'Molasses Reef',
    'FWYF1': 'Fowey Rock',
    'VAKF1': 'Virginia Key',
    'LKWF1': 'Lake Worth',
    'CHLV2': 'Chesapeake Light',
    'CBBV2': 'Chesapeake Bay Bridge',
    'SWPV2': 'Sewells Point',
    'YKTV2': 'Yorktown',
    'RPLV2': 'Rappahannock Light',
    'WASD2': 'Washington DC',
    'BLTM3': 'Baltimore',
    'APAM2': 'Annapolis',
    'CMAN4': 'Cape May',
    'SDHN4': 'Sandy Hook',
    'BATN6': 'The Battery NY',
    'BGNN4': 'Bergen Point',
    'ACYN4': 'Atlantic City',
    'PHBP1': 'Philadelphia',
    'DELD1': 'Delaware City',
    'LWSD1': 'Lewes',
    'OCIM2': 'Ocean City Inlet',
    'SLIM2': 'Solomons Island',
    'TPLM2': 'Tolchester',
    'BISM2': 'Bishops Head',
    'CAMM2': 'Cambridge',
    'FSKM2': 'Francis Scott Key Bridge',
    'NCDV2': 'Dahlgren',
    'LWTV2': 'Lewisetta',
    'KPTV2': 'Kiptopeke',
    'CBIM2': 'Cove Point',
    'PPTM2': 'Piney Point',
    '42039': 'Pensacola Buoy',
    '42040': 'Mobile South Buoy',
    '42012': 'Orange Beach Buoy',
    '42013': 'Cape San Blas Buoy'
  };
  
  return stationNames[stationId] || stationId;
};

// Suggest beach flag based on weather conditions
export const suggestFlagBasedOnConditions = (weather) => {
  if (!weather?.current) return null;
  
  const windSpeed = weather.current.wind_speed_10m || 0;
  const waveHeight = weather.current.wave_height || 0;
  
  // Red flag conditions
  if (windSpeed > 25 || waveHeight > 6) {
    return {
      suggested: '🔴',
      reason: 'High winds or waves detected'
    };
  }
  
  // Yellow flag conditions
  if (windSpeed > 15 || waveHeight > 3) {
    return {
      suggested: '🟡',
      reason: 'Moderate conditions detected'
    };
  }
  
  // Green flag conditions
  return {
    suggested: '🟢',
    reason: 'Calm conditions'
  };
};

// Get next tide from tide array
export const getNextTide = (tides) => {
  if (!tides || tides.length === 0) return null;
  
  const now = new Date();
  const currentTime = now.getTime();
  
  // Find the next tide after current time
  const nextTide = tides.find(tide => {
    const tideTime = new Date(tide.t).getTime();
    return tideTime > currentTime;
  });
  
  if (!nextTide) return null;
  
  const tideTime = new Date(nextTide.t);
  const isHigh = nextTide.type === 'H';
  
  return {
    type: isHigh ? 'High' : 'Low',
    time: tideTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }),
    height: nextTide.v,
    rawTime: tideTime
  };
};